import moment from "moment";

export const id = new Date().getTime() + Math.random().toString(36).substring(2, 24);

export function getMessageToken() {
  const currentTimestampInMilliseconds = Date.now();
  const timestampInSeconds = Math.floor(currentTimestampInMilliseconds / 1000);
  const timestampMicroseconds = (currentTimestampInMilliseconds % 1000) * 1000;
  const pubnubTimestamp = timestampInSeconds * 1000000 + timestampMicroseconds;
  // console.log(`PubNub Timestamp: ${pubnubTimestamp}`);
  return pubnubTimestamp.toString();
}

export const formattedDate = moment(new Date()).format("DD/MM/YYYY");

export function findDifferentObjects(arr1, arr2) {
  const diffObjects = [];
  if (arr2?.length > 0) {
    arr2.forEach((obj2) => {
      const obj1 = arr1.find((item) => item._id === obj2._id);
      if (!obj1) {
        diffObjects.push(obj2);
      }
    });
  }

  return diffObjects;
}
